import { PublicMenuItem } from "@/components/layout/PublicMenu/PublicMenuUtils";

export const LOGIN: PublicMenuItem = {
  path: "/welcome",
  icon: "key",
  translationKey: "navi.login",
  alignment: "right",
};
export const PAGES: PublicMenuItem[] =
	[
		{
			path: "/faq",
			translationKey:
				"navi.faq",
			icon: "",
			alignment: "left",
		},
		{
			path: "/documents",
			translationKey:
				"navi.documents",
			icon: "",
			alignment: "left",
		},
		{
			path: "/contact",
			translationKey:
				"navi.contact",
			icon: "",
			alignment: "left",
		},

		{
			path: "/signup",
			icon: "user-plus",
			translationKey:
				"navi.create",
			alignment: "right",
		},
	];

// TODO: once env is adapted, remove fallbacks
export const COORDINATES = (import.meta.env.VITE_COORDINATES?.split(',').map(c => Number(c)) ?? [49.422776, 8.64028]) as [number, number];
export const OWMAPPID = import.meta.env.VITE_OWMAPPID ?? "1e54a65c85d0885600a4573240fb9fb9";

